import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import {SITE_NAME} from '../Constants';
import Gallery from '../components/Gallery';
import {demoImages} from '../demoData';
import {onResetSelectionDemo, onToggleSelectImageDemo} from '../actions/ImageActions';
import {SelectionToolbar} from '../components/SelectionToolbar';
import {withRouter} from 'react-router-dom';
import {hasOpenModal as hasOpenModalInternal} from '../reducers/modals';
import {onDownloadDemoSelection, onPrintDemoSelection} from '../actions/DemoActions';

@withRouter
@connect(state => ({
    demo: state.demo,
    hasOpenModal: () => hasOpenModalInternal(state.modals),
}), {
    onToggleSelectImage: onToggleSelectImageDemo,
    onResetSelection: onResetSelectionDemo,
    onPrintSelection: onPrintDemoSelection,
    onDownloadSelection: onDownloadDemoSelection,
})
export default class DemoGalleryContainer extends Component {
    static propTypes = {
        demo: PropTypes.object,
        onToggleSelectImage: PropTypes.func,
        onResetSelection: PropTypes.func,
        onDownloadSelection: PropTypes.func,
        onPrintSelection: PropTypes.func,
        history: PropTypes.object,
        hasOpenModal: PropTypes.func,
    };

    render() {
        const {demo, history} = this.props;
        const {id, selectedImages} = demo;
        const sortedSelectedImages = [...selectedImages].sort();

        return (
            <div>
                <SelectionToolbar
                    urlPrefix="/demo"
                    selectedImages={sortedSelectedImages}
                    onResetSelection={this.props.onResetSelection}
                    onPrintSelection={this.props.onPrintSelection}
                    onDownloadSelection={this.props.onDownloadSelection}
                    history={history}
                    hideEditButtons={true}
                />
                <div className="page">
                    <Helmet>
                        <title>{`${SITE_NAME} - Demo Gallery`}</title>
                    </Helmet>
                    <div className="images-content">
                        <h1>{'Gallery'}</h1>
                        <div className="card">
                            <Gallery
                                urlPrefix="/demo"
                                images={demoImages}
                                lastVisitedId={id}
                                selectedImages={sortedSelectedImages}
                                onToggleSelectImage={this.props.onToggleSelectImage}
                                hideEditButtons={true}
                                onResetSelection={this.props.onResetSelection}
                                hasOpenModal={this.props.hasOpenModal}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/DemoGalleryContainer.js